import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogInput, CatalogRecommendation, ChatMessage, ContextManager, RecommendationInput, RecommendationState, RecommendationStateService, RecommenderService } from '@urbannex/product-multi-recommender';
import { BehaviorSubject, Subscription, throwError } from 'rxjs';
import { AssistantConfig } from '@urbannex/view-containers';
import { NbLayoutModule, NbButtonModule } from '@nebular/theme';
import { CatalogNodeComponent } from './catalog-node/catalog-node.component';
import { InputPanelComponent } from '../input-panel/input-panel.component';
import { OutPutItem, RecommendationServicesService } from '../../services/recommendation-services.service';

export interface CategoryNode extends CatalogRecommendation{
  name: string;
  children: CategoryNode[];
  parent?: CategoryNode;
  selected?: boolean;
  expanded?: boolean;
  indeterminate?: boolean; // For parent nodes with some but not all children selected
  level?: number;
}

@Component({
  selector: 'ubs-catalog-recommender',
  standalone: true,
  imports: [CommonModule,InputPanelComponent,NbLayoutModule,NbButtonModule,CatalogNodeComponent],
  templateUrl: './catalog-recommender.component.html',
  styleUrls: ['./catalog-recommender.component.scss'],
  providers: [ RecommenderService, RecommendationStateService ]
})
export class CatalogRecommenderComponent implements OnInit, OnChanges, OnDestroy {
  @Input() assistantConfig:AssistantConfig;
  state!: RecommendationState;
  private stateSubscription!: Subscription;
  name:string;                              //The name of the assistant
  assistantDescription:string;             //The description for the assistant
  path:string;

  messages: ChatMessage[] = [];
  content:any = [];
  nodes: CategoryNode[] = [];
  selectedCategories: CategoryNode[] = [];

  // Emits true if any category is selected or indeterminate
  private anyCategorySelectedSubject = new BehaviorSubject<boolean>(false);
  anyCategorySelected$ = this.anyCategorySelectedSubject.asObservable();

  readonly hasSelections$ = this.chatStateService.hasSelections$;
  hasSelections:boolean;


  readonly hasMessages$ = this.chatStateService.hasMessages$;
  readonly isSelected$ = this.chatStateService.isSelected$;

  @Output() selectionChange = new EventEmitter<CategoryNode[]>();
  
  constructor(
      private stateService: RecommendationStateService,
      private recommender: RecommenderService,
      private chatStateService:RecommendationServicesService,
      private context: ContextManager
    ) {
      this.chatStateService.init();
      this.stateService.setCatalogStep();
      /* this.hasSelections$.subscribe((hasSelections:boolean) => {
        this.hasSelections = hasSelections;
      }) */
    }

  ngOnInit() {
    console.log("ngOnInit method called");
    this.stateSubscription = this.stateService.state$.subscribe(state => {
      this.state = state;

      console.log('State updated:', state);
      this.updateMessages(state);
    });
  }

  private updateMessages(state: RecommendationState) {
    this.messages = [];
    // Add ccatalogs if present
    console.log('State:', state);
    if (state.catalogs.length > 0) {
      this.messages.push({
        type: 'catalog',
        content: state.catalogs,
        timestamp: new Date()
      });
      const processedNode = this.calculateFullPaths(state.catalogs[0]);
      this.nodes.push(processedNode);
      //this.nodes = state.catalogs;
      this.initializeNodeLevels(this.nodes,0);
      //this.nodes = this.calculateFullPaths(this.nodes);
      console.log('Catalogs:', this.nodes);
      this.chatStateService.hasMessages(true)
    }
  }

  private initializeNodeLevels(nodes: CategoryNode[], level: number) {
    nodes.forEach(node => {
      node.level = level;
      node.selected = false;
      node.expanded = level === 0; // Expand root level by default
      if (node.children?.length) {
        this.initializeNodeLevels(node.children, level + 1);
      }
    });
  }
 /**
 * Populates the fullPath property for each node in the tree
 * @param rootNode - The root node of the tree
 * @returns A new tree with fullPath populated for each node
 */
calculateFullPaths(rootNode: CategoryNode): CategoryNode {
  if (!rootNode) {
    return null;
  }

  // Create a deep copy of the tree to avoid mutating the original
  const result = JSON.parse(JSON.stringify(rootNode)) as CategoryNode;
  
  // Set the fullPath for the root node
  result.fullPath = result.name;
  
  // Process all children recursively
  this.processChildren(result);
  console.log("Full path calculated",result);
  return result;
}
/**
 * Recursively processes all children of a node to set their fullPath
 * @param node - The current node whose children need processing
 */
processChildren(node: CategoryNode): void {
  if (!node.children || node.children.length === 0) {
    return;
  }
  
  for (const child of node.children) {
    // Set the fullPath for this child based on its parent's fullPath
    child.fullPath = `${node.fullPath} > ${child.name}`;
    
    // Recursively process this child's children
    this.processChildren(child);
  }
}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['assistantConfig']) {
      console.log(this.assistantConfig);
      if(this.assistantConfig != undefined){
        console.log(this.assistantConfig);
        this.name = this.assistantConfig?.name;
        this.assistantDescription = this.assistantConfig?.capabilities[0].description
        if(this.assistantConfig?.path != undefined){
          this.path = this.assistantConfig?.path;
        }
      }
      
      
      //this.context.setAssistantConfig(this.assistantConfig);
    }
  }

  toggleExpanded(node: CatalogRecommendation) {
    node['_expanded'] = !node['_expanded'];
  }

  selectCatalog(category: CatalogRecommendation) {
    console.log('Selected catalog category:', category.fullPath);
    // You can emit an event here if needed
  }

  handleTextInput(query: any){
     console.log("handleTextInput method called", query);
    console.log("text received")
    this.stateService.setLoading(true);
    
    const baseInput: RecommendationInput = {
      userInput: query,
      taxonomyVersion: 'latest' // Add your taxonomy version
    };

    console.log(query);
    const list = query.split(",");
    const catalogInput: CatalogInput = {
      
      ...baseInput,
      productTypes: list,
      marketRegion: 'US' // Default or user-selected
    };
    this.recommender.getCatalogRecommendations(catalogInput)
    .subscribe({
      next: (response) => {
        console.log('Catalog recommendations:', response);
        const catalogs = response.recommendations
        /* const catalogs = response.recommendations.map(c => ({
          c.fullPath,
          c.
        })); */
        this.stateService.updateCatalogs(catalogs);
        this.stateService.setLoading(false);
      },
      error: (error) => {
        console.error('Error fetching catalog recommendations:', error);
        this.handleError(error);
      }
    })
  }

  private handleError(error: any) {
    this.stateService.setError(error.message || 'An unexpected error occurred');
    return throwError(() => error);
  }
  //Should be replaced with select catalog
  
  selectCategory(event: { node: CategoryNode; selected: boolean }) {
    
    // Immutably update the entire tree
    console.log("selectCategory method called", event.node, event.selected);
    //this.nodes = this.updateTreeWithNewNode(this.nodes, event.node);
    console.log(`SelectedNodes:${this.nodes}`)
    this.nodes.forEach((node) => {
      if(node === event.node){
        console.log({"This is the node selected by click":node});
      }else{
        console.log({"This node has not been selected by click":node});
      }
      
    })
    this.selectionChange.emit(this.nodes);
    // Recalculate the "any selected" state
    const anySelected = this.checkAnyCategorySelected(this.nodes);
    this.anyCategorySelectedSubject.next(anySelected);
    //this.selectedCategories = this.getSelectedCategories();
    if(this.selectedCategories.length > 0){
      this.selectedCategories.forEach((category) => {
        console.log({"Selected category ":category});
      })
    }
    //this.nodes = this.updateParentStates(event.node,this.nodes);
    this.updateParentStates(event.node,this.nodes);
    this.chatStateService.hasSelections(anySelected)
    //console.log(`SelectedCategories:${this.selectedCategories}`)
  }

  private checkAnyCategorySelected(nodes: CategoryNode[]): boolean {
    let found = false;

    const traverse = (node: CategoryNode) => {
      if (node.selected || node.indeterminate) {
        found = true;
        return;
      }
      if (node.children?.length) {
        for (const child of node.children) {
          traverse(child);
          if (found) return;
        }
      }
    };

    for (const node of nodes) {
      traverse(node);
      if (found) break;
    }

    return found;
  }

  createAcceptedCatalog() {
    const selected = this.getSelectedCategories(this.nodes);
    console.log("Selected categories : ", selected);
    const selectedLeaves = this.getSelectedLeafCategories(this.nodes);
    console.log("Selected leaf categories : ", selectedLeaves);
    // Handle selection
    //this.stateService.updateCatalogs(selected);
    this.chatStateService.isSelected(true);
    this.chatStateService.outPutHeader("Selected Catalog Categories");
    this.chatStateService.outPutDescription("These are the selected categories for your catalog");
    this.createOutPutItems(selected,selectedLeaves);
  }

  private createOutPutItems(selected:CategoryNode[],selectedLeaves:CategoryNode[]){
    const outPutItems = selected.map((category) => {
      return {
        name: category.name,
        children: category.children,
        fullPath: category.fullPath,
        hierarchy: category.hierarchy,
        hierarchyLevel: category.hierarchyLevel,
        taxonomyVersion: category.taxonomyVersion
      }
    });
    const selectedLeavesItems = selectedLeaves.map((category) => {
      return {
        name: category.name,
        children: category.children,
        fullPath: category.fullPath,
        hierarchy: category.hierarchy,
        hierarchyLevel: category.hierarchyLevel,
        taxonomyVersion: category.taxonomyVersion
      }
    });
    let firstItem:OutPutItem = {
      header: "Category Tree",
      description: "This tree will be used to create the nodes for your catelog",
      items:outPutItems.map((category) => category.fullPath)
    }
    let secondItems:OutPutItem = {
      header: "Selected Categories",
      description: "These categories will be used to generate category features",
      items:selectedLeavesItems.map((category) => category.name)
    }
    let outPutItemsArray:OutPutItem[] = [firstItem,secondItems];
    this.chatStateService.outPutItems(outPutItemsArray);
    this.chatStateService.hasSelections(true);
  }

  // Traverses the full tree to update parents based on their children's state
  updateIndeterminateStates(nodes: CategoryNode[]): void {
    for (const node of nodes) {
      if (node.children?.length) {
        this.updateIndeterminateStates(node.children); // bottom-up recursion

        const allSelected = node.children.every(c => c.selected && !c.indeterminate);
        const noneSelected = node.children.every(c => !c.selected && !c.indeterminate);

        node.selected = allSelected;
        node.indeterminate = !allSelected && !noneSelected;
      }
    }
  }


  private updateTreeWithNewNode(nodes: CategoryNode[], modifiedNode: CategoryNode): CategoryNode[] {
    console.log("updateTreeWithNewNode method called", nodes, modifiedNode);
    return nodes.map(node => {
      if (node === modifiedNode) {
        return modifiedNode; // Already updated immutably in toggleNodeAndChildren
      }
  
      // Recursively search children
      if (node.children?.length) {
        return {
          ...node,
          children: this.updateTreeWithNewNode(node.children, modifiedNode)
        };
      }
  
      return node;
    });
  }
  //Old selectCategory function - should be deleted
  _selectCategory(nodeData: {node: CategoryNode, selected: boolean}) {
    const { node, selected } = nodeData;
    console.log("selectCategory method called", node, selected);
    // Apply selection to all children
    /* if (node.children?.length) {
      this.selectChildren(node.children, selected);
    } */
    
    // Update parent states
    //this.nodes = this.updateParentStates(node,this.nodes);
    this.updateParentStates(node,this.nodes);
    // If using OnPush change detection, ensure reference changes:
    //this.nodes = [...this.nodes];
    
    // Emit the selection change event
    this.selectionChange.emit(this.getSelectedCategories(this.nodes));
  }

  private selectChildren(children: CategoryNode[], selected: boolean) {
    console.log("Selecting all children")
    children.forEach(child => {
      child.selected = selected;
      child.indeterminate = false;
      if (child.children?.length) {
        this.selectChildren(child.children, selected);
      }
    });
  }

  /* private updateParentStates(nodes: CategoryNode[]) {
    nodes.forEach(node => {
      if (node.children?.length) {
        this.updateParentStates(node.children);
        
        // Calculate parent state based on children
        const selectedCount = node.children.filter(child => child.selected).length;
        const indeterminateCount = node.children.filter(child => child.indeterminate).length;
        
        if (selectedCount === node.children.length) {
          // All children selected
          node.selected = true;
          node.indeterminate = false;
        } else if (selectedCount === 0 && indeterminateCount === 0) {
          // No children selected
          node.selected = false;
          node.indeterminate = false;
        } else {
          // Some children selected or indeterminate
          node.selected = false;
          node.indeterminate = true;
        }
      }
    });
  } */

  updateParentStates(modifiedNode: CategoryNode, nodes: CategoryNode[]): void {
    console.log("updateParentStates method called", modifiedNode, nodes);
    // Check if the modified node has a parent
    if (!modifiedNode.parentId) return;
    const parentNode = this.findNodeById(nodes, modifiedNode.parentId);
    //const parentNode = nodes.find(node => node.id === modifiedNode.parentId);
    if (!parentNode) return;
    console.log({"Parent node found":parentNode});
    // Update the parent node's state based on its children
    const allChildrenSelected = parentNode.children?.every(c => c.selected);
    const someChildrenSelected = parentNode.children?.some(c => c.selected || c.indeterminate);
    const noneSelected = parentNode.children.every(c => !c.selected && !c.indeterminate);
    if(allChildrenSelected){
      parentNode.selected = true;
      parentNode.indeterminate = false;
    }else if (noneSelected) {
      parentNode.selected = false;
      parentNode.indeterminate = false;
    } else if(someChildrenSelected){
      parentNode.selected = false;
      parentNode.indeterminate = true;
    }
    this.updateParentStates(parentNode,nodes)
    /* return nodes.map(node => {
      // Clone node to ensure immutability
      const updatedNode = { ...node };
  
      // Recursively search for the modified node's parent
      if (updatedNode.children) {
        updatedNode.children = this.updateParentStates(modifiedNode, updatedNode.children);
        
        // Update current node's state based on children
        const allChildrenSelected = updatedNode.children.every(c => c.selected);
        const someChildrenSelected = updatedNode.children.some(c => c.selected || c.indeterminate);
  
        updatedNode.selected = allChildrenSelected;
        updatedNode.indeterminate = !allChildrenSelected && someChildrenSelected;
      }
      console.log({"Updated node":updatedNode});
      return updatedNode;
    }); */
  }

  // This function should be in a service or utility file
  updateParentState(node: CategoryNode): CategoryNode {
    if (!node.children?.length) return node;
  
    // Recalculate state based on children
    const allChildrenSelected = node.children.every(c => c.selected);
    const someChildrenSelected = node.children.some(c => c.selected || c.indeterminate);
  
    return {
      ...node,
      selected: allChildrenSelected,
      indeterminate: !allChildrenSelected && someChildrenSelected
    };
  }
  // Add this to a service or utility file
_updateParentState(node: CategoryNode): CategoryNode {
  if (!node.children?.length) return node;

  // Recalculate state based on children
  const allChildrenSelected = node.children.every(c => c.selected);
  const someChildrenSelected = node.children.some(c => c.selected || c.indeterminate);

  return {
    ...node,
    selected: allChildrenSelected,
    indeterminate: !allChildrenSelected && someChildrenSelected
  };
}

  /* getSelectedCategories(): CategoryNode[] {
    const selected: CategoryNode[] = [];
    this.findSelectedNodes(this.nodes, selected);
    return selected;
  } */
    getSelectedCategories(nodes: CategoryNode[]): CategoryNode[] {
      const selected: CategoryNode[] = [];
    
      const traverse = (node: CategoryNode) => {
        const hasChildren = !!node.children?.length;
    
        if (node.selected || node.indeterminate) {
          selected.push(node);
        }
    
        if (hasChildren) {
          node.children.forEach(traverse);
        }
      };
    
      nodes.forEach(traverse);
      return selected;
    }
  getSelectedLeafCategories(nodes: CategoryNode[]): CategoryNode[] {
    const selectedLeaves: CategoryNode[] = [];
  
    const traverse = (node: CategoryNode) => {
      const hasChildren = !!node.children?.length;
  
      if (!hasChildren && node.selected) {
        selectedLeaves.push(node);
      }
  
      if (hasChildren) {
        node.children.forEach(traverse);
      }
    };
  
    nodes.forEach(traverse);
    return selectedLeaves;
  }

  private findSelectedNodes(nodes: CategoryNode[], result: CategoryNode[]): void {
    for (const node of nodes) {
      if (node.selected) {
        // Create a copy of the node without children to avoid circular references
        result.push({
          name: node.name,
          children: [],
          fullPath: '',
          hierarchy: [],
          hierarchyLevel: 0,
          taxonomyVersion: ''
        });
      } else if (node.indeterminate) {
        // If parent is indeterminate, we need to check children
        if (node.children?.length) {
          this.findSelectedNodes(node.children, result);
        }
      }
    }
  }

  findNodeById(nodes: CategoryNode[], targetId: string): CategoryNode | undefined {
    for (const node of nodes) {
      if (node.id === targetId) {
        return node;
      }
      if (node.children && node.children.length > 0) {
        const found = this.findNodeById(node.children, targetId);
        if (found) return found;
      }
    }
    return undefined;
  }

  ngOnDestroy() {
    if (this.stateSubscription) {
      this.stateSubscription.unsubscribe();
    }
  }

}
